interface AppConfig {
  apiBaseUrl: string;
}

declare global {
  interface Window {
    __APP_CONFIG__?: AppConfig;
  }
}

export const config: AppConfig = {
  apiBaseUrl: window.__APP_CONFIG__?.apiBaseUrl ?? "",
};
